import React from "react"; // eslint-disable-line no-unused-vars
import { LabelEvent } from "./calendar-utils";
import { readableColor, lighten } from "polished";
import { DragSource } from "react-dnd";
import styled from "styled-components";

const EventContainer = styled.div`
  display: flex;
  border-right: 1px solid #fff;
  border-top: 1px solid #fff;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${props => (props.color ? props.color : "green")};
  border-color: ${props =>
    props.color ? lighten(0.09, props.color) : lighten(0.09, "green")};
  color: ${props => (props.color ? readableColor(props.color) : "#fff")};
  padding: 2px;
  font-size: 0.7em;
  cursor: pointer;
  &:hover {
    background-color: ${props =>
      props.color ? lighten(0.1, props.color) : lighten(0.1, "green")};
  }
`;
const EventContainerDragging = EventContainer.extend`
  box-shadow: inset 0 0 10px #000000;
`;

const EventSource = {
  beginDrag(props) {
    const isDraggingId = props.id;
    props.updateSelectedTypeId.call(null, props.slotType, isDraggingId);
    return props;
  },
  endDrag(props) {
    props.updateSelectedTypeId(null);
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
    //    connectDragPreview: connect.dragPreview()
  };
}

class Event extends React.Component {
  render() {
    const { connectDragSource, isDragging } = this.props;
    if (isDragging) {
      return connectDragSource(
        <div
          style={{
            height: this.props.height, //* this.props.duration,
            zIndex: 2
          }}
        >
          <EventContainerDragging color={this.props.color}>
            {/*<LabelEvent>{this.props.label}</LabelEvent>-->*/}
          </EventContainerDragging>
        </div>
      );
    }
    return connectDragSource(
      <div
        style={{
          height: this.props.height * this.props.duration,
          zIndex: 2
        }}
      >
        <EventContainer
          color={this.props.color}
          onClick={this.props.eventSlotClick}
        >
          <LabelEvent>{this.props.label}</LabelEvent>
        </EventContainer>
      </div>
    );
  }
}

export default DragSource("event", EventSource, collect)(Event);



// WEBPACK FOOTER //
// ./src/components/utilities/calendar/Event.js